// @core/api/endpoints/userprofile/set_userprofile_default.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  SetUserprofileDefaultRequest,
} from '../../../types/userprofile';

const BASE_PATH = '/userprofile';

/**
 * Set default profile for user
 * Designates a profile as the default for a user who has multiple profiles. The default profile is used when no specific profile is selected.
 */
export async function SetUserprofileDefault(
  user_id: string,
  profile_id: string,
  data: SetUserprofileDefaultRequest,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/user/:user_id/default/:profile_id`;
  requestPath = requestPath.replace(':user_id', encodeURIComponent(user_id));
  requestPath = requestPath.replace(':profile_id', encodeURIComponent(profile_id));
  const requestOptions = options;
  return client.post<Response>(requestPath, data, requestOptions);
}
